/**
 * 导入所有 vuex 模块
 * namespaced:true 开启命名空间，解决vuex命名冲突，请勿修改。
 */

import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedstate from 'vuex-persistedstate' // 持久化存储
import app from './modules/app';
import numberPortal from './modules/numberPortal'
import wechat from './modules/wechat'
Vue.use(Vuex);

const modules = {
    app,
    numberPortal,
    wechat
};

Object.keys(modules).forEach(key => {
    modules[key]['namespaced'] = true;
});

const store = new Vuex.Store({
    state: {
        menuId: 0, // 菜单id
        navPath: '/home', // 导航path
        $is2024: true,
    },
    mutations: {
        SET_IS2024(state, status) {
            state.$is2024 = status;
        },
        SET_NAV_PATH(state, status) {
            state.navPath = status;
        },
        SET_NEMU_ID(state, id) {
            state.menuId = id;
        }
    },
    getters: {
        menuId: (state) => state.menuId,
        $is2024: (state) => state.$is2024
    },
    modules,
    plugins: [
        createPersistedstate({
            key: 'numberPortal',
            paths: ['numberPortal'],
            storage: window.localStorage
        })
    ]
});

export default store;
